import React, { useState, useCallback, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { useDropzone } from 'react-dropzone';
import {
	Box,
	Button,
	Image,
	Input,
	Text,
	Heading,
	useToast,
} from '@chakra-ui/react';
import uploadIcon from '../../../assets/upload_icon.png';
import AutoTypeText from '../multistepform/autotype';
import { saveAs } from 'file-saver';
import VendorAdvancePaginatedData from './vendorAdvancePaginatedData';
import { useSelector } from 'react-redux';
import { useAdvances } from '../../../Context/AdvancesContext';

const VendorAdvances = () => {
	const toast = useToast();
	const [data, setData] = useState([]);
	const [editing, setEditing] = useState(false);
	const companyId = useSelector((state) => state.companyId);
	const selectedLocation = useSelector((state) => state.selectedLocation);
	const selectedBranch = useSelector((state) => state.selectedBranch);
	const locationCode = useSelector((state) => state.locationCode);
	const [errors, setErrors] = useState([]);
	const [hasValidationErrors, setHasValidationErrors] = useState(false);
	const [uploadMessageExcel, setUploadMessageExcel] = useState(undefined);
	const [errorValue, setErrorValue] = useState();
	const [totalOpenBalance, setTotalOpenBalance] = useState(null);
	const [vendorList, setVendorList] = useState({ message: [], parentGlValue: 0 });
	const [pagesWithErrors, setPagesWithErrors] = useState(new Set());
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 50;
	const { advancesvendor, positiveMissingCustomers } = useAdvances();

	console.log('advancesvendor🟠', advancesvendor);


	const [validationWarnings, setValidationWarnings] = useState([]);

	function bigPrint(number) {
		if (number == null || isNaN(number)) return 0;
		return +number.toString();
	}

	function formatDateToDdMmYy(date) {
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	}

	const currentDate = new Date();
	const formattedDate = formatDateToDdMmYy(currentDate);

	const excelDateToJSDate = (serial) => {
		const utc_days = Math.floor(serial - 25569);
		const utc_value = utc_days * 86400;
		const date_info = new Date(utc_value * 1000);
		return date_info;
	};

	const handleFileDrop = useCallback((acceptedFiles) => {
		const file = acceptedFiles[0];
		const reader = new FileReader();

		reader.onload = (event) => {
			const data = new Uint8Array(event.target.result);
			const workbook = XLSX.read(data, { type: 'array' });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];

			const excelData = XLSX.utils.sheet_to_json(worksheet, {
				header: 1,
				raw: true
			});

			const headers = excelData[0].map((header) => header.trim());
			const dateColumns = ['Transaction_Date', 'Invoice_Date', 'Date'];

			const formattedData = excelData.slice(1).map((row) => {
				const rowData = {};

				row.forEach((cell, columnIndex) => {
					const header = headers[columnIndex];

					if (dateColumns.includes(header) && typeof cell === 'number') {
						const jsDate = excelDateToJSDate(cell);
						rowData[header] = formatDateToDdMmYy(jsDate);
					} else {
						rowData[header] = cell;
					}
				});

				return rowData;
			});
			const emptyRow = Object.fromEntries(headers.map((header) => [header, '']));
			const dataWithEmptyKeys = formattedData.map((row) => ({
				...emptyRow,
				...row,
			}));
			const keyFields = ['Vendor_Code', 'vendor_code', 'vendor_gstin', 'vendor_name'];
			const nonBlankRows = dataWithEmptyKeys.filter((row) =>
				keyFields.some((field) => row[field] !== null && row[field] !== '')
			);

			setData(nonBlankRows);
			setUploadMessageExcel(undefined);
		};

		reader.readAsArrayBuffer(file);
	}, []);

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop: handleFileDrop,
		accept: '.xlsx',
	});


	// useEffect(() => {
	// 	if (!data.length) {
	// 		setValidationWarnings([]);
	// 		return;
	// 	}

	// 	const warnings = [];

	// 	data.forEach((row) => {
	// 		const vendorCodeRaw = row.Vendor_Code || row.vendor_code || '';
	// 		const vendorCode = vendorCodeRaw.toString().trim();

	// 		const advanceAmount = parseFloat(row.AdvanceAmount);

	// 		// 🔹 Check with advancesvendor
	// 		const matchedAdvanceObj = advancesvendor.find(
	// 			(item) => item.code === vendorCode
	// 		);

	// 		// 🔹 Check with positiveMissingCustomers
	// 		const matchedPositiveCustomer = positiveMissingCustomers.find(
	// 			(item) => item.code === vendorCode
	// 		);

	// 		if (matchedAdvanceObj) {
	// 			const expectedAdvance = parseFloat(matchedAdvanceObj.advance);

	// 			if (isNaN(advanceAmount)) {
	// 				warnings.push(
	// 					`Warning: Advance Amount is invalid for Vendor Code ${vendorCode}`
	// 				);
	// 			} else if (advanceAmount !== expectedAdvance) {
	// 				warnings.push(
	// 					`Warning: Advance Amount (${advanceAmount}) must be exactly ${expectedAdvance} for Vendor Code ${vendorCode}`
	// 				);
	// 			}
	// 		}

	// 		if (matchedPositiveCustomer) {
	// 			const limitValue = parseFloat(matchedPositiveCustomer.limitValue);

	// 			if (!isNaN(advanceAmount) && advanceAmount > limitValue) {
	// 				warnings.push(
	// 					`Validation: Advance Amount (${advanceAmount}) exceeds limit (${limitValue}) for Vendor Code ${vendorCode}`
	// 				);
	// 			}
	// 		}

	// 		// 🔹 Only show "No advance info" if not found in BOTH lists
	// 		if (!matchedAdvanceObj && !matchedPositiveCustomer) {
	// 			warnings.push(
	// 				`Warning: No advance info found for Vendor Code ${vendorCode}`
	// 			);
	// 		}
	// 	});

	// 	setValidationWarnings(warnings);
	// }, [data, advancesvendor, positiveMissingCustomers]);

	useEffect(() => {
		if (!data.length) {
			setValidationWarnings([]);
			return;
		}

		const warnings = [];

		// 🔹 Aggregate total AdvanceAmount per Vendor_Code
		const vendorAdvanceMap = data.reduce((acc, row) => {
			const vendorCodeRaw = row.Vendor_Code || row.vendor_code || '';
			const vendorCode = vendorCodeRaw.toString().trim();
			const advanceAmount = parseFloat(row.AdvanceAmount) || 0;

			if (!acc[vendorCode]) {
				acc[vendorCode] = 0;
			}
			acc[vendorCode] += advanceAmount;
			return acc;
		}, {});

		Object.entries(vendorAdvanceMap).forEach(([vendorCode, totalAdvance]) => {
			// 🔹 Check with advancesvendor
			const matchedAdvanceObj = advancesvendor.find(
				(item) => item.code === vendorCode
			);

			// 🔹 Check with positiveMissingCustomers
			const matchedPositiveCustomer = positiveMissingCustomers.find(
				(item) => item.code === vendorCode
			);

			if (matchedAdvanceObj) {
				const expectedAdvance = parseFloat(matchedAdvanceObj.advance);

				if (totalAdvance !== expectedAdvance) {
					warnings.push(
						`Warning: Total Advance Amount (${totalAdvance}) must be exactly ${expectedAdvance} for Vendor Code ${vendorCode}`
					);
				}
			}

			if (matchedPositiveCustomer) {
				const limitValue = parseFloat(matchedPositiveCustomer.limitValue);

				if (totalAdvance > limitValue) {
					warnings.push(
						`Validation: Total Advance Amount (${totalAdvance}) exceeds limit (${limitValue}) for Vendor Code ${vendorCode}`
					);
				}
			}

			// 🔹 Only show "No advance info" if not found in BOTH lists
			if (!matchedAdvanceObj && !matchedPositiveCustomer) {
				warnings.push(
					`Warning: No advance info found for Vendor Code ${vendorCode}`
				);
			}
		});

		setValidationWarnings(warnings);
	}, [data, advancesvendor, positiveMissingCustomers]);



	const handleDownload = () => {
		const sampleData = [
			{
				Vendor_Code: '',
				Vendor_Name: '',
				Currency: '',
				AdvanceAmount: '',
				Bank_Name: '',
				Transaction_Date: '',
				Transaction_Id: '',
			}
		];

		const worksheet = XLSX.utils.json_to_sheet(sampleData);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Sample');

		const excelBuffer = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array'
		});

		const blob = new Blob([excelBuffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});

		saveAs(blob, `Vendor-Advances-Sample-${locationCode}-${formattedDate}.xlsx`);
	};

	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	return (
		<Box
			width='100%'
			height='100%'
			display='flex'
			justifyContent='center'
			alignItems='center'
			flexDirection='column'>
			<Box w='100%' display='flex' justifyContent='space-around'>
				<Box
					width='38%'
					display='flex'
					justifyContent='space-around'
					alignItems='center'>
					<Box width='400px'>
						<Box
							border='2px dashed var(--chakra-colors-bgGraycolor)'
							p='15px'
							borderRadius='20px'
							opacity={editing ? '0.5' : '1'}
							pointerEvents={editing ? 'none' : 'painted'}>
							<Box
								{...getRootProps()}
								bg='var(--chakra-colors-mainBlueColor)'
								width='100%'
								height='100%'
								borderRadius='20px'
								display='flex'
								justifyContent='center'
								alignItems='center'
								color='white'
								padding='50px 0px'
								cursor='grab'>
								<Input {...getInputProps()} />
								{isDragActive ? (
									<Box
										display='flex'
										flexDirection='column'
										justifyContent='center'
										alignItems='center'>
										<Image
											src={uploadIcon}
											alt='upload icon'
											height='100px'
											width='100px'
										/>
										<Text>Drop the Excel file here...</Text>
									</Box>
								) : (
									<Box
										display='flex'
										flexDirection='column'
										justifyContent='center'
										alignItems='center'>
										<Image
											src={uploadIcon}
											alt='upload icon'
											height='100px'
											width='100px'
										/>
										<Text>Drag & Drop your files</Text>
									</Box>
								)}
							</Box>
						</Box>
						<Box
							display='flex'
							width='100%'
							justifyContent='center'
							gap='15px'
							paddingTop='45px'>
							<Button
								borderRadius='10px'
								border='1px solid #003060'
								p='20px 30px'
								width='50%'
								fontSize='15px'
								background='none'
								color='mainBlueColor'
								onClick={handleDownload}
								cursor='pointer'>
								Download Sample
							</Button>
						</Box>
					</Box>
				</Box>

				<Box
					width='58%'
					boxShadow='rgba(0, 0, 0, 0.24) 0px 3px 8px'
					borderRadius='15px'
					padding='15px'>
					<Heading
						mb='15px'
						color='var(--chakra-colors-mainBlueColor)'
						fontSize='28px'>
						Data Summary :{' '}
					</Heading>
					<Text
						fontSize='1.7rem'
						fontWeight='600'
						marginBottom='10px'
						color='green'>
						Total lines : {data?.length}
					</Text>
					<Text
						fontSize='1.7rem'
						fontWeight='600'
						marginBottom='10px'
						color='red'>
						Total Error : {errorValue}
					</Text>
					{validationWarnings.length > 0 && (
						<Box mb="10px">
							{validationWarnings.map((warn, i) => (
								<Text
									key={i}
									fontSize="1.5rem"
									fontWeight="600"
									color="red"
									mb="2px"
								>
									{warn}
								</Text>
							))}
						</Box>
					)}
					<Text
						fontSize='1.7rem'
						fontWeight='600'
						color='mainBlueColor'
						marginBottom='5px'>
						Balance: {bigPrint(totalOpenBalance)}
					</Text>
					<Box mt='10px' mb='10px'>
						<Box
							fontSize='1.7rem'
							fontWeight='600'
							color='mainBlueColor'>
							Pages with errors:
						</Box>
						{Array.from(pagesWithErrors).join(', ')}
					</Box>
					<Box>
						<Text
							fontSize='1.7rem'
							fontWeight='600'
							color='mainBlueColor'
							marginBottom='5px'>
							Data Review Report -
						</Text>
						<AutoTypeText />
					</Box>
				</Box>
			</Box>
			<VendorAdvancePaginatedData
				data={data}
				setData={setData}
				currentPage={currentPage}
				itemsPerPage={itemsPerPage}
				editing={editing}
				setEditing={setEditing}
				onPageChange={handlePageChange}
				setTotalOpenBalance={setTotalOpenBalance}
				setErrorValue={setErrorValue}
				errorValue={errorValue}
				errors={errors}
				setErrors={setErrors}
				hasValidationErrors={hasValidationErrors}
				setHasValidationErrors={setHasValidationErrors}
				setPagesWithErrors={setPagesWithErrors}
				uploadMessageExcel={uploadMessageExcel}
				setUploadMessageExcel={setUploadMessageExcel}
				isParentGlValues={true}
			/>
		</Box>
	);
};

export default VendorAdvances;